var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.2252 8.81145C9.83465 8.42092 9.20148 8.42092 8.81096 8.81145C8.42044 9.20197 8.42044 9.83514 8.81096 10.2257L14.5857 16.0004L8.81102 21.7751C8.4205 22.1656 8.42049 22.7988 8.81102 23.1893C9.20154 23.5798 9.83471 23.5798 10.2252 23.1893L15.9999 17.4146L21.7746 23.1893C22.1651 23.5798 22.7983 23.5798 23.1888 23.1893C23.5793 22.7988 23.5793 22.1656 23.1888 21.7751L17.4141 16.0004L23.1889 10.2257C23.5794 9.83514 23.5794 9.20197 23.1889 8.81145C22.7983 8.42092 22.1652 8.42092 21.7746 8.81145L15.9999 14.5862L10.2252 8.81145Z","fill":"white"}));
}

Close.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Close;

Close.default = Close;
